import React from 'react';
import './Hero.css';

interface HeroProps {
  onForgeClick: () => void;
}

const PRODUCT_GLIMPSES = [
  {
    label: 'Discover',
    title: 'Your Archetype',
    image: '/archetype-cosmic-mirror.jpg',
    className: 'hero-artifact--archetype',
  },
  {
    label: 'Understand',
    title: 'Cosmic Blueprint',
    image: '/step2-blueprint.jpg',
    className: 'hero-artifact--blueprint',
  },
  {
    label: 'Evolve With',
    title: 'Your Oracle',
    image: '/oracle-avatar.jpg',
    className: 'hero-artifact--oracle',
  },
];

const Hero: React.FC<HeroProps> = ({ onForgeClick }) => {
  return (
    <section className="hero">
      <div
        className="hero-bg"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/hero-bg.jpg)` }}
        aria-hidden="true"
      />
      <div className="hero-copy-veil" aria-hidden="true" />

      <div className="hero-content">
        <p className="hero-eyebrow">The Genesis of You</p>
        <h1 className="hero-title">
          <span className="hero-title-line">Know Your Soul.</span>
          <span className="hero-title-line hero-title-accent">Transform Your Life.</span>
        </h1>
        <p className="hero-subtitle">
          Your birth chart, personality, and spiritual path woven into one living blueprint that evolves with you.
        </p>

        <div className="hero-cta-group">
          <button type="button" className="hero-cta-primary" onClick={onForgeClick}>
            Forge My Blueprint
            <span className="cta-arrow" aria-hidden="true">→</span>
          </button>
          <p className="hero-cta-sub">Free · 5 minutes · No credit card</p>
        </div>
      </div>

      <div className="hero-product-preview" aria-label="A glimpse inside Zeal Genesis">
        <p className="hero-preview-label">A glimpse of what awaits</p>
        <div className="hero-artifact-stack">
          {PRODUCT_GLIMPSES.map(item => (
            <div className={`hero-artifact ${item.className}`} key={item.title}>
              <img src={`${process.env.PUBLIC_URL}${item.image}`} alt="" aria-hidden="true" />
              <div className="hero-artifact-shade" />
              <div className="hero-artifact-copy">
                <span>{item.label}</span>
                <strong>{item.title}</strong>
              </div>
            </div>
          ))}
        </div>
        <div className="hero-scroll-cue" aria-hidden="true"><span /></div>
      </div>
    </section>
  );
};

export default Hero;
